import CustomElement from '../core/custom.js'

const SELECTORS = {
  city: '.js-city-item',
  detail: '.js-city-detail'
}

export default window.customElements.define(
  'block-cities',
  class extends CustomElement {
    constructor() {
      super()

      this.events = {
        [`mouseenter ${SELECTORS.city}`]: 'onMouseEnter'
      }
    }

    connectedCallback() {
      super.connectedCallback()

      this.$cities = this.querySelectorAll(SELECTORS.city)
      this._details = Array.from(this.querySelectorAll(SELECTORS.detail))
    }

    disconnectedCallback() {
      super.disconnectedCallback()
    }

    onMouseEnter(event) {
      event.preventDefault()
      const index = Number(event.target.dataset.cityIndex)

      this.$cities.forEach((el, i) => {
        el.classList.toggle('is-active', i == index)
        this._details[i].classList.toggle('is-active', i == index)
      })
    }
  }
)
